import { requestApi } from './Api';

export const getPatients = async (navigate, params) =>
  requestApi({ navigate, url: '/api/practice/charts/get', params });

// Adapter: backend patient row → option shape consumed by the navbar search.
export const mapPatientToSearchOption = (element) => ({
  label: element?.fullName,
  value: element?.id,
  id: element?.id,
  dob: element?.dob,
  phone: element?.phone,
  profilePhoto: element?.profile_photo,
  email: element?.email,
  f_name: element?.f_name,
  l_name: element?.l_name,
  preferredName: element?.p_name
});

export const getPatientsAdmin = async (navigate, params) =>
  requestApi({ navigate, url: '/api/patient/get/multiple', params });

export const getPatient = async (navigate, params) =>
  requestApi({ navigate, url: '/api/patient/get/one', params });

export const getPatientPracticeLinks = async (navigate, params) =>
  requestApi({ navigate, url: '/api/admin/patient/link/list', params });

export const checkPatientSelfScheduling = async (navigate, params, ...options) =>
  requestApi({
    navigate,
    url: '/api/patient/services/check_self_scheduling',
    params,
    ...options
  });

export const updateProfilePicture = async (navigate, params) =>
  requestApi({ navigate, url: '/api/filestack/profile_photo', params });

export const updatePatient = async (navigate, options) =>
  requestApi({
    url: '/api/user/update',
    params: options,
    navigate
  });

export const getPracticePatientLink = async (navigate, params) =>
  requestApi({ navigate, url: '/api/practice/patient/link/get', params });

export const updatePracticePatientLink = async (navigate, options) =>
  requestApi({
    url: '/api/practice/patient/link/update',
    params: options,
    navigate
  });

export const createPatient = async (navigate, options) =>
  requestApi({
    url: '/api/practice/patient/add_patient',
    params: options,
    navigate
  });

export const chartExport = async (navigate, options) =>
  requestApi({
    url: '/api/practice/charts/export',
    params: options,
    navigate
  });

export const mergePatients = async (navigate, options) =>
  requestApi({
    url: '/api/practice/charts/merge',
    params: options,
    navigate
  });

export const getPatientMessages = async (navigate, params) =>
  requestApi({
    url: '/api/messages/inbox',
    params,
    navigate
  });

export const getPatientWeightLossGoal = async (navigate, params) =>
  requestApi({
    url: '/api/patient/weight_loss_goal/get',
    params,
    navigate
  });
export const upsertPatientWeightLossGoal = async (navigate, params, onSuccess, onError) =>
  requestApi({
    url: '/api/patient/weight_loss_goal/upsert',
    params,
    navigate,
    onSuccess,
    onError
  });

export const getCheckinPatient = async (navigate, params) =>
  requestApi({ navigate, url: '/api/patient/checkin/get_patient', params });

export const getPatientForms = async (navigate, params) =>
  requestApi({ navigate, url: '/api/patient/forms/get', params });

export const getPatientICDCodes = async (navigate, params, onSuccess, onError) =>
  requestApi({
    url: '/api/patient/icd/get',
    params,
    navigate,
    onSuccess,
    onError
  });

export const getPatientCPTCodes = async (navigate, params, onSuccess, onError) =>
  requestApi({
    url: '/api/patient/cpt/get',
    params,
    navigate,
    onSuccess,
    onError,
    throwError: true
  });

export const upsertPatientICD10Codes = async (navigate, params) =>
  requestApi({
    url: '/api/patient/icd/upsert',
    params,
    navigate
  });

export const deletePatientICD10Code = async (navigate, params) =>
  requestApi({
    url: '/api/patient/icd/delete',
    params,
    navigate
  });

export const updatePracticePatient = async (navigate, params) =>
  requestApi({ navigate, params, url: 'api/practice/patient/update' });

export const applySpecificSpecialty = async (navigate, params, onSuccess) =>
  requestApi({
    url: '/api/patient/insurance/apply_specific_specialty',
    params,
    navigate,
    onSuccess
  });

export const checkInsuranceValidity = (navigate, params) =>
  requestApi({
    params,
    navigate,
    url: '/api/patient/insurance/is_valid'
  });

export const getChartActivity = (navigate, params) =>
  requestApi({
    navigate,
    url: '/api/practice/charts/activity/get',
    params
  });

export const getChartActivitySecureSSN = (navigate, params) =>
  requestApi({
    navigate,
    url: '/api/practice/charts/activity/secure/get',
    params
  });

export const getPatientProviders = async (navigate, params) =>
  requestApi({
    navigate,
    params,
    url: '/api/patient/providers/get'
  });
